import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

// TODO: cleanup, way too many ant overrides

export const StyledPopup = styled.div`
  position: relative;
`;

export const StyledClose = styled.span`
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
`;

export const StyledRecentFilters = styled.div`
  max-height: 100px;
  overflow-y: auto;
  :global {
    .ant-btn {
      @color: #696969;

      color: @color;
      border-color: @color;

      &:hover {
        color: @color;
        border-color: @color;
      }

      &:active {
        color: @color;
        border-color: @color;
      }
    }
  }
`

export const ModalMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
  opacity: var(--modal-light-opacity, 0.1);
  z-index: 70;
  background-color: rgb(0, 0, 0);
  background-color: var(--model-background, rgb(0, 0, 0));
  & + div {
    z-index: 71;
  }
`;

export const FilterWrapper = styled.div`
  @media (min-width: 900px) {
    max-width: 800px;
  }
  width: 100%;
  ${breakpoint('mobile')`
      width: 200%;
  `};
  background-color: #ffffff;
  position: absolute;
  padding: 1rem;
  box-shadow: 1px 2px 4px 0 rgba(0,0,0,0.2);
  border-radius: 3px;
  & .ant-dropdown-menu-item-disabled .ant-dropdown-menu-submenu-title-disabled {
    background: none !important;
  }
  & .ant-tabs-tab {
    margin: 0px 5px 5px 0px !important;
    background-color: #ffffff !important;
  }
  & .ant-tabs-tab-active {
    color: #0046FF !important;
    background-color: #e9f3fd !important;
  }

  & .ant-collapse-content-box > div:hover {
    background-color: #e9f3fd !important;
  }

  & .ant-select-selection {
    background-color: #ffffff !important;
    .ant-select-selection__choice {
      background-color: #f6f6f6 !important;
    }
  }

  & .ant-checkbox-wrapper:hover {
    background-color: #e9f3fd !important;
  }

  & div[class^='filter-pill'] .ant-checkbox-wrapper-checked {
    background-color: #e9f3fd !important;
    border-color: #215bff !important;
  }

  & .ant-checkbox-inner {
    background: none !important;
  }

  & .ant-checkbox-inner::after {
    border-color: #1890ff !important;
  }

  & .ant-select-selection {
    max-height: 85px;
    overflow: auto;
  }

  & .ant-tabs-extra-content a {
    color: #1890ff !important;
  }

  & .ant-select-dropdown {
    background-color: #ffffff  !important;
    border: 1px solid #ddd !important;
    i svg path {
      color: #ffffff !important;
    }
    & .ant-select-dropdown-menu-item-selected,
    & .ant-select-dropdown-menu-item:hover {
      background-color: #e9f3fd !important;
      i svg path {
        color: #17253a !important;
      }
    }
  }
`;

export const FilterLabelWrapper = styled.div`
  position: relative;
  width: 50%;
  max-width: 800px;
  display: flex;
  flex-grow: 1;
`;

export const FilterTitleWrapper = styled.div`
  cursor: pointer;
  margin: .1rem 0 .2rem;
  display: block;
  position: relative;
  height: 2rem;
  max-height: 2rem;
`;

export const BreadcrumbWrapper = styled.div`
  margin-top: 5px;
  * {
    font-size: 0.8rem;
  }
`;

export const FilterTitle = styled.div`
  display: block;
  margin: 0 auto;
  max-height: 2rem;
  line-height: 2rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: .8rem;
  padding-bottom: .5rem;
  background-color: #f6f6f6;
  padding: 0 .5rem .2rem .8rem;
  max-width: 100%;
  overflow-x: hidden;
  min-height: 2rem;
`;

export const StyledHeader = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  margin: 0;
  line-height: .9;
  position: relative;
  display: inline-block;
  max-width: 100%;
`;

export const VerticalBar = styled.span`
  position: absolute;
  width: .3rem;
  top: 0;
  left: 0;
  bottom: 0;
  background: ${({ filterColor }: { filterColor: string }) => filterColor};
  z-index: 1;
`;
